"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_bracelet__put__on__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "1c246240-026f-4d42-9e6d-92086df86566",
    "data-name": "ICON",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("title", null, "bracelet-put-on-hi-dark"), /*#__PURE__*/React.createElement("path", {
    d: "M120.48,176H71.53a8.26,8.26,0,0,1-8.14-6.38L56.05,137.5a2.3,2.3,0,0,1,0-.45V55a2.3,2.3,0,0,1,0-.45l7.34-32.12A8.26,8.26,0,0,1,71.53,16h49.86a8.3,8.3,0,0,1,8.18,6.59l6.39,32a1.67,1.67,0,0,1,0,.39v82.1a2.3,2.3,0,0,1-.05.45l-7.34,32.12A8.25,8.25,0,0,1,120.48,176Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,140H64a8,8,0,0,1-8-8V60a8,8,0,0,1,8-8h64a8,8,0,0,1,8,8v72A8,8,0,0,1,128,140Z",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128,140H64a8,8,0,0,1-8-8v2a8,8,0,0,0,8,8h64a8,8,0,0,0,8-8v-2A8,8,0,0,1,128,140Z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128,50H64a8,8,0,0,0-8,8v2a8,8,0,0,1,8-8h64a8,8,0,0,1,8,8V58A8,8,0,0,0,128,50Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M58,132V60a8,8,0,0,1,8-8H64a8,8,0,0,0-8,8v72a8,8,0,0,0,8,8h2A8,8,0,0,1,58,132Z",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,52h-2a8,8,0,0,1,8,8v72a8,8,0,0,1-8,8h2a8,8,0,0,0,8-8V60A8,8,0,0,0,128,52Z",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.85,128a8.06,8.06,0,0,0-7.8,6,8.06,8.06,0,0,0,7.8,6h64.3a8.06,8.06,0,0,0,7.8-6,8.06,8.06,0,0,0-7.8-6Z",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,52a8,8,0,0,0-7.75,6A8,8,0,0,0,64,64h64a8,8,0,0,0,7.75-6A8,8,0,0,0,128,52Z",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,138H64a8,8,0,0,1-8-8v2a8,8,0,0,0,8,8h64a8,8,0,0,0,8-8v-2A8,8,0,0,1,128,138Z",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.03,
    y: 36,
    width: 60,
    height: 4,
    rx: 1.94,
    ry: 1.94,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.03,
    y: 28,
    width: 58,
    height: 4,
    rx: 1.9,
    ry: 1.9,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.03,
    y: 20,
    width: 56,
    height: 4,
    rx: 1.87,
    ry: 1.87,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 152,
    width: 60,
    height: 4,
    rx: 1.94,
    ry: 1.94,
    transform: "translate(192 308) rotate(180)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67,
    y: 160,
    width: 58,
    height: 4,
    rx: 1.9,
    ry: 1.9,
    transform: "translate(192 324) rotate(-180)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 168,
    width: 56,
    height: 4,
    rx: 1.87,
    ry: 1.87,
    transform: "translate(192 340) rotate(180)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "111 86 90 106 81 97.43",
    fill: "none",
    stroke: "#f4f4f4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }));
}

var _default = ic_bracelet__put__on__dark;
exports.default = _default;